// When the page finishes loading...
window.addEventListener('load', function() {

    // Get price match guarantee dialog elements by their IDs.
    var priceMatchGuaranteeDialogOpenButton = document.getElementById("price-match-guarantee-open");
    var priceMatchGuaranteeDialogCloseButton = document.getElementById("price-match-guarantee-close");
    var priceMatchGuaranteeDialogOverlay = document.getElementById("price-match-guarantee-dialog-overlay");

    // When the open button is clicked, prevent the default action and open the dialog.
    priceMatchGuaranteeDialogOpenButton.addEventListener("click", function(event) {
        event.preventDefault();
        priceMatchGuaranteeDialogOverlay.classList.add('open');
    });

    // When the close button is clicked, prevent the default action and close the dialog.
    priceMatchGuaranteeDialogCloseButton.addEventListener("click", function(event) {
        event.preventDefault();
        priceMatchGuaranteeDialogOverlay.classList.remove('open');
    });

    // When the overlay is clicked...
    priceMatchGuaranteeDialogOverlay.addEventListener("click", function(event) {

        // If the overlay was the target of the click, prevent the default action and close the dialog.
        if (event.target.id === "price-match-guarantee-dialog-overlay") {
            event.preventDefault();
            priceMatchGuaranteeDialogOverlay.classList.remove('open');
        }

    });

});